import cn from "classnames";
import { MouseEvent } from "react";
import { A11yChild } from "../../a11y";
import { DropdownItemProps } from "./types";
import styles from "./styles.module.scss";

export const DropdownItem = ({
  hasA11yFocus,
  a11yChildRef,
  content,
  onClick,
  disabled,
  className,
  dataTestId,
  ...otherDropdownItemAttributes
}: DropdownItemProps) => {
  const handleMouseDown = (event: MouseEvent<HTMLButtonElement>) => {
    // предотвращаем установку фокуса
    event.preventDefault();
  };

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    onClick?.(event);
  };

  return (
    <li className={cn(styles.item, { [styles.disabled]: disabled }, className)}>
      <A11yChild hasA11yFocus={hasA11yFocus} a11yChildRef={a11yChildRef}>
        <button
          {...otherDropdownItemAttributes}
          className={styles.content}
          onMouseDown={handleMouseDown}
          onClick={handleClick}
          disabled={disabled}
          data-test-id={dataTestId}
        >
          <span>{content}</span>
        </button>
      </A11yChild>
    </li>
  );
};
